<template>
  <div class="filterGrid__contentWrapper">
    <div v-imageloaded class="filterGrid__imageWrapper image__loading">
      <img
        class="lazyload"
        :sizes="item.itemResult.image.sizes"
        :alt="item.itemResult.image.alt"
        :aria-hidden="true"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        :srcset="item.itemResult.image.dataSrcset"
      />
    </div>
    <div class="Grid__contentWrapper">
      <span v-if="item.itemResult.categoryHierarchy" class="filterGrid__categoryHierarchy">
        {{ categoryHierarchy }}
      </span>
      <h3>
        <a
          v-tag:useractionevent="{
            category: 'content page',
            action: 'select::article',
            label: item.itemResult.title,
            module_name: 'article list',
            cta_name: item.itemResult.label,
            link_url: `${urlOrigin}${item.url}`,
            article_name: item.itemResult.title,
            event_name: 'body_button_click',
          }"
          class="filterGrid__title"
          :href="item.url"
          :aria-label="generateAriaLabel(item.itemResult.title, item.itemResult.label)"
        >
          {{ item.itemResult.title }}
        </a>
      </h3>
      <span v-if="item.itemResult.credits" class="filterGrid__credits">
        {{ item.itemResult.credits }}
      </span>
      <span v-if="item.itemResult.creationDate" class="filterGrid__creationDate">
        {{ item.itemResult.creationDate }}
      </span>
      <span v-if="isWishlistEnabled" class="wishlist-like-button">
        <Favouritearticle
          :wishlist-img="wishlistImg"
          :unwishlist-img="unwishlistImg"
          :wishlist-alt="wishlistAlt"
          :unwishlist-alt="unwishlistAlt"
          :title="item.itemResult.title"
          :label="item.itemResult?.label"
          :url="item.url"
          :image-srcset="item.itemResult.image?.dataSrcset"
          :image-sizes="item.itemResult.image?.sizes"
          :image-alt="item.itemResult.image?.alt"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Favouritearticle from '../../../../Wishlist/code/Scripts/components/WishList/favourite/favouriteArticle.vue';
import { imageloaded } from '@Foundation/directives/imageloaded/imageloaded';
import { tag } from '@Foundation/analyticsHandler/directives/tag';

export default {
  name: 'ArticleCard',
  components: { Favouritearticle },
  directives: {
    imageloaded,
    tag,
  },

  props: {
    item: { type: Object, required: true },
    wishlistImg: {
      type: String,
      default: '',
    },
    unwishlistImg: {
      type: String,
      default: '',
    },
    wishlistAlt: {
      type: String,
      default: '',
    },
    unwishlistAlt: {
      type: String,
      default: '',
    },
    isWishlistEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    urlOrigin() {
      return window.location.origin;
    },
    categoryHierarchy() {
      return this.item.itemResult.categoryHierarchy.replaceAll('-', '\u2014');
    },
  },
  methods: {
    generateAriaLabel(title, label) {
      let generateAriaLabel;
      if (title || label) {
        generateAriaLabel = `${title || ''} ${label ? `(${label})` : ''}`;
      } else {
        generateAriaLabel = false;
      }
      return generateAriaLabel;
    },
  },
};
</script>
<style lang="scss" scoped>
.wishlist-like-button {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;
  width: 32px;
  height: 32px;
  cursor: pointer;
  button {
    padding: 0px;
  }
}
</style>
